import { useEffect } from 'react';
import { MAX_TOAST_TIME, MIN_TOAST_TIME } from "./constants";
import { ToastContent } from "./ui/ToastContent";
import { jsx as _jsx } from "react/jsx-runtime";
export var Toast = function Toast(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 4 : _ref$duration,
    open = _ref.open,
    onClose = _ref.onClose,
    type = _ref.type,
    title = _ref.title,
    subtitle = _ref.subtitle,
    textLink = _ref.textLink;
  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!open) return;
    var showTime = duration;

    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (duration < MIN_TOAST_TIME) showTime = MIN_TOAST_TIME;
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (duration > MAX_TOAST_TIME) showTime = MAX_TOAST_TIME;
    var timeout = setTimeout(function () {
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (open) onClose();
    }, showTime * 1000);
    return function () {
      return clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, duration]);
  return open ? /*#__PURE__*/_jsx("div", {
    className: "tw-fixed tw-flex tw-w-full tw-justify-center sm:tw-w-auto tw-top-2.4 sm:tw-top-4 sm:tw-right-4 tw-z-popover",
    children: /*#__PURE__*/_jsx(ToastContent, {
      title: title,
      subtitle: subtitle,
      textLink: textLink,
      type: type,
      onClose: onClose
    })
  }) : null;
};
export default Toast;